if(document.documentMode) {
    document.documentElement.className+=' ie ie'+document.documentMode;
}

$(window).resize(function(){
    if($('.page.homepage').length) {
        window.slider.setHomeSize();
        $('.page').css('left', $('.header__inner').offset().left);
    }

    if(window.innerWidth < 961 && !$('.menuicon').length)
        setNavigationResponsive();

    if(window.innerWidth > 961) {
        if($('.menuicon').length)
            unsetNavigationResponsive();
    }

    setBookingFixed();

});
    $(window).scroll(function(){
        if($(window).width()>960){

            if($(window).scrollTop()>=399){
                $(".header__button").fadeIn(500);
            }
            else{

                $(".header__button").fadeOut(500);
            }
        }
    })

    $(window).scroll(function(){
        $('.header').toggleClass('header--fixed', $(window).scrollTop() > 50);
        $('.menuicon').toggleClass('fixed', $(window).scrollTop() > 50);
        if($(window).scrollTop() > 50){
            $('.table-cell img').attr("src",$('.table-cell img').data('img-scroll'));
            console.log("scrolll img")
        }
        else{
            $('.table-cell img').attr("src",$('.table-cell img').data('img-original'));
            console.log("scrolll img")
        }

    });

$(document).ready(function(){
    setTimeout(function(){
        $("header").css("background", "none");
    },3000)
    $('.fancygallery').fancybox({
        showNavArrows: true
    });
    $('.homepage-text').mCustomScrollbar({
        mouseWheel: {
            enable: true
        }
    });

    if(window.innerWidth < 961) {setNavigationResponsive();}

    setBookingFixed();

    if($('.homepage').length && window.innerWidth >= 600) {
        if(window.innerWidth > 960) {
            $('.page').css('left', $('.header__inner').offset().left);
            $('.page').css('width', $('.header__inner').outerWidth() - $('.bookingbox').outerWidth());
        }

        setBookingFixed();

    }else {
        cloneBookingBox();
    }


    if($('.aboutrooms__frontend').outerHeight() > $('.aboutrooms__background').outerHeight()) {
        $('.aboutrooms__background').css('height', $('.aboutrooms__frontend').outerHeight() + 30);
    }else {
        $('.aboutrooms__background').css('height', 'auto');
    }

    /**
     * HOMEPAGE BACKGROUND SLIDER AND OTHERS PAGE BACKGROUND SLIDER
     */
    if($('.header__slider, .header__inner').length) {
            window.slider = new HomeSlider();
            if($('.page.homepage').length) {
                $('.abouthotel').show('fade', 800);
                window.slider.setHomeSize();
                $(".header__slider").css("opacity", "0");
                setTimeout(function(){ $(".header__slider").css("opacity", "1"); }, 500);

            }else {
                window.slider.setOthersSize();
                $(".header__slider").css("opacity", "0");
                setTimeout(function(){ $(".header__slider").css("opacity", "1"); }, 500);
            }
        setTimeout(function(){
            $('.header__slider li').coverSizer({
                selector: 'img'
            }).find('img').css({
                position: 'absolute',
                right: 'auto'
            });
        }, 800);
    }

    /**
     * BXSLIDERx§§
     */
    var slides = 2;
    var slideWidth = 265;
    if(window.innerWidth < 1260) {
        slides = 1;
    }

    if(window.innerWidth < 1440) {
        slideWidth = 235;
    }
    if(window.innerWidth <= 768) {
        //slider.destroySlider();
        slides=2;
    }
    if(window.innerWidth <= 660) {
        //slider.destroySlider();
        slides=1;
    }
    if(window.innerWidth <= 320) {
        /*slider.destroySlider();*/

    }
    if(window.innerWidth < 1050) {
        //slideWidth = 250;
    }


    if($('.homepage__bxslider_new').length) {
        $('.homepage__bxslider_new').bxSlider({
            pager: false,
            controls: true,
            minSlides: slides,
            maxSlides: slides,
            slideWidth: slideWidth
        });
    }

    var nowDate = new Date(),
        $checkIn = $('#checkIn'),
        $checkOut = $('#checkOut');

    $checkIn.datepicker({
        altField: $('#checkInAlt'),
        altFormat: 'yy-mm-dd',
        minDate: 0,
        onClose: function() {
            $checkOut.datepicker('option', 'minDate', new Date($checkIn.datepicker('getDate').getTime() + 24*60*60*1000));
        }
    }).datepicker('setDate', nowDate);
    $checkOut.datepicker({
        altField: $('#checkOutAlt'),
        altFormat: 'yy-mm-dd',
        minDate: 1
    }).datepicker('setDate', new Date(nowDate.getTime() + 24*60*60*1000));

    if($(window).outerHeight() > 640 && $(window).outerWidth() > 900) {
        if($('.actionbox').length) {
            $(".actionbox").animate({
                left: '+=' + 670
            }, 500);
        }
    }

});

$(document).ready(function(){
    var $hpTextHeader = $('.homepage__cols-header .text-title');
    $hpTextHeader.click(function(evt) {
        evt.preventDefault();
        $('.homepage-text').stop(true).slideToggle();
        $(this).toggleClass("open");
    });

})

$(window).load(function() {
    if($('.room__picture').length) {
        $('.room__picture').each(function(){
            $(this).bxSlider({
                pager: true,
                controls: false
            });

            if($(window).outerWidth() > 660) {
                var block = $(this).closest('.room__block');
                var blockHeight = block.outerHeight();
                block.find('.room__body').css('min-height', blockHeight);
            }
        });
    }
});

function setBookingFixed() {
    var offset = null;
    var bookingbox = $('.bookingbox');
    var bookingboxWidth = bookingbox.outerWidth();

    if($('.homepage').length) {
        offset = $('.homepage .wrapper').outerWidth() + $('.homepage .wrapper').offset().left;
        bookingbox.css('left', offset - bookingboxWidth);

    }else {
        offset = $('.header__inner').outerWidth() + $('.header__inner').offset().left;
        bookingbox.css('left', offset - bookingboxWidth);
    }
}

function cloneBookingBox() {
    $('.bookingbox').clone().appendTo('header');
    $('.bookingbox').eq(1).remove();
}

$(function() {
    var $button = $('.bookingbox__submit');

    $button.on('click', function(event){
        triggerBookingBox($(this), event);
    });

    //setTimeout(function(){ $button.trigger("click") }, 5000);

    $('.bookingbox__close').click(function() {
        triggerBookingBox($(this), event);
    });
});

function triggerBookingBox(caller, event) {
    var bookingBox = $('.bookingbox');
    var button = bookingBox.find('.bookingbox__submit');

    if(!bookingBox.hasClass('isOpened')) {
        event.preventDefault();
        bookingBox.find('fieldset').show('blind', 300, function(){
            bookingBox.addClass('isOpened', 200);
        });
    } else {
        if(/*caller.parents('.bookingbox').length < 1 || */caller.hasClass('bookingbox__close')){
            event.preventDefault();
            bookingBox.find('fieldset').hide('blind', 300, function(){
                bookingBox.removeClass('isOpened', 200);
            });
        }
    }
}

$(document).on('click', '.langs li:first-child', function(event){
    event.preventDefault();
    event.stopPropagation();
    var firstLang = $(this);

    if(firstLang.hasClass('isOpened')) {
        firstLang.removeClass('isOpened');
        firstLang.closest('.langs').removeClass('isOpened', 250);
    }else {
        firstLang.addClass('isOpened');
        firstLang.closest('.langs').addClass('isOpened', 250);
    }
});

$(document).on('click', 'body', function(event){
    if($('.langs li:first-child').hasClass('isOpened')) {
        if(!$(event.target).closest('.langs').length)
            $('.langs li:first-child').trigger('click');
    }

    if(typeof window.slidebar !== 'undefined')
        window.slidebar.slidebars.close();

    if($('.bookingbox').hasClass('isOpened'))
        triggerBookingBox($(event.target), event);
});


$(document).on('click', '.newlogic-icon__icon', function(event){
    $('.newlogic-icon__content').fadeToggle();
});

$(function() {
    $('.room__see').fancybox({
        wrapCSS: 'room-detail',
        type: 'ajax',
        maxWidth: 1110,
        arrows: false,
        afterShow: function() {
            console.log(arguments);
            $('.room-detail__gallery').bxSlider({});
        }
    });
});

$(document).on('click', '.room-detail__navigation__button--prev', function(event){
    event.preventDefault();
    $.fancybox.prev();
});

$(document).on('click', '.room-detail__navigation__button--next', function(event){
    event.preventDefault();
    $.fancybox.next();
});

$(document).on('click', '.menuicon', function(event){
    event.preventDefault();
    event.stopPropagation();
    window.slidebar.slidebars.toggle('left');
});

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function setNavigationResponsive() {
    $('body').append('<span class="menuicon"><span class="menuicon__line"></span><span class="menuicon__line"></span><span class="menuicon__line"></span><span class="menuicon__title">MENU</span></span>');
    $('body').append('<div class="sb-slidebar sb-left sb-momentum-scrolling sb-style-push"></div>')
    $('.navigation').clone().appendTo('.sb-slidebar').removeClass('navigation').addClass('navigationslidebar').prepend('<button title="Close" class="fancybox-item fancybox-close">X</button>');
    $(".langs").addClass("mobile-langs").appendTo(".navigationslidebar");
    window.slidebar = new $.slidebars();
}

function unsetNavigationResponsive() {
    $('.menuicon, .sb-slidebar').remove();
}

function cutImages() {
    window.images = [];
    window.boxes = [];

    $('.gallery__box').each(function(){
        window.boxes.push($(this));
    });

    $('.gallery__box .gallery__item').each(function(){
        window.images.push($(this));
    });

    $('.gallery__box').remove();
    $('.gallery').addClass('response').append(window.images);
}
